class UnboundSlider extends HTMLElement {
  connectedCallback() {
    const wrapper = this.querySelector(".images-wrapper");
    const dotsContainer = this.querySelector(".dots");

    if (!wrapper) return;

    const slider = new KeenSlider(wrapper, {
      loop: true, 
      slides: {
        perView: 5,
        spacing: 9,
      },
      breakpoints: {
        "(max-width: 749px)": {
          slides: { perView: 2, spacing: 10 },
        },
      },
      created: (s) => {
        if (dotsContainer) this.createDots(s, dotsContainer);
      },
    });

    if (dotsContainer) {
      slider.on("optionsChanged", () => this.createDots(slider, dotsContainer));
      slider.on("updated", () => this.createDots(slider, dotsContainer));
    }
  }

  createDots(slider, dotsContainer) {
    const totalSlides = slider.slides.length; 
    const originalCount = slider.track.details.slides.length; 

   
    const pages = originalCount;

    dotsContainer.innerHTML = "";

    for (let i = 0; i < pages; i++) {
      const dot = document.createElement("button");
      dot.classList.add("dot");
      dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
      dot.addEventListener("click", () => slider.moveToIdx(i));
      dotsContainer.appendChild(dot);
    }

    this.updateDots(slider, dotsContainer);

    slider.on("slideChanged", () => {
      this.updateDots(slider, dotsContainer);
    });
  }

  updateDots(slider, dotsContainer) {
    const dots = dotsContainer.querySelectorAll(".dot");
    const current = slider.track.details.rel % dots.length; 
    dots.forEach((dot, idx) => {
      dot.classList.toggle("active", idx === current);
    });
  }
}

if (!customElements.get("unbound-slider")) {
  customElements.define("unbound-slider", UnboundSlider);
}
